import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import './DialogRowError.sass';

function DialogRowError({ open, handleCloseErrorDialog, errors }) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={handleCloseErrorDialog}
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: "paperProps" }}
    >
      <DialogTitle 
        className="dialog_title"
      >
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar className="dialog_avatar">
            <ErrorOutlineIcon fontSize="small" />
          </Avatar>
          <Typography variant="h6" className="error_text">
            {t('error_selected_row')}
          </Typography>
        </Box>
        <IconButton 
          onClick={handleCloseErrorDialog} 
          size="small"
          className="color_black"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className="dialog_content">
        <Stack spacing={1}>
          {errors.length === 0 ? (
            <Typography variant="body2">{t('no_error_found')}</Typography>
          ) : (
            errors.map((error) => (
              <Paper
                key={error?.id}
                variant="outlined"
                className="paper"
              >
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Typography
                    variant="body2"
                    className="stack1"
                  >
                    {t(error.record)}
                  </Typography>
                  <Box 
                    className="box1"
                  />
                  <Typography
                    variant="body2"
                    className="typography1"
                  >
                    {error.errorMessage}
                  </Typography>
                </Stack>
              </Paper>
            ))
          )}
        </Stack>
      </DialogContent>

      <DialogActions className="dialog_action">
        <Button 
          onClick={handleCloseErrorDialog}
          size="small"
         className="close"
        >
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogRowError;